import { DashboardRecentSpenderListRestEndpointService } from '@api'
import { useMutation, useQueryClient } from 'react-query'

import { useToast } from '@/components/ui/toast'
import { handleError } from '@/utils/error'

export function useRecentSpendListMutations(creatorId: number) {
  const toast = useToast()
  const queryClient = useQueryClient()

  const createRecentSpendList = useMutation({
    mutationFn: (variables: { name: string; minutes: number }) =>
      DashboardRecentSpenderListRestEndpointService.dashboardCreateRecentSpenderList(
        {
          creatorId,
          requestBody: {
            name: variables.name,
            amountOfMinutes: variables.minutes,
          },
        },
      ),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'recent-spend-list'],
      })

      toast.success(`List "${variables.name}" created successfully`)
    },
    onError: (error) => {
      handleError(error, 'Failed to create recent spend list')
    },
  })

  const deleteRecentSpendList = useMutation({
    mutationFn: (listId: number) =>
      DashboardRecentSpenderListRestEndpointService.dashboardDeleteRecentSpenderList(
        {
          creatorId,
          listId,
        },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'recent-spend-list'],
      })

      toast.success('List deleted successfully')
    },
    onError: (error) => {
      handleError(error, 'Failed to delete recent spend list')
    },
  })

  const editRecentSpendList = useMutation({
    mutationFn: (variables: {
      listId: number
      name: string
      amountOfMinutes: number
    }) =>
      DashboardRecentSpenderListRestEndpointService.dashboardUpdateRecentSpenderList(
        {
          creatorId,
          listId: variables.listId,
          requestBody: {
            name: variables.name,
            amountOfMinutes: variables.amountOfMinutes,
          },
        },
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['creator', creatorId, 'recent-spend-list'],
      })

      toast.success('List edited successfully')
    },
    onError: (error) => {
      handleError(error, 'Failed to edit recent spend list')
    },
  })

  return {
    createRecentSpendList,
    deleteRecentSpendList,
    editRecentSpendList,
  }
}
